import type { User } from './supabase';
import type { AccountProfile } from './account-profile';

export function accountIdentity(user: User | null, profile: AccountProfile | null) {
  const profileName = profile?.display_name?.trim();
  const name = profileName || 'User';
  const initials = avatarInitials(profileName, user?.email);
  // A removed Account photo must not silently revert to an OAuth-provider photo.
  return { name, initials, image: profile?.avatar_image || null };
}

/** First + last display-name initials; otherwise only the email's first letter. */
export function avatarInitials(displayName?: string | null, email?: string | null) {
  const parts = (displayName || '').trim().split(/\s+/).filter(Boolean);
  return parts.length
    ? [parts[0], ...(parts.length > 1 ? [parts[parts.length - 1]] : [])].map(part => Array.from(part)[0]).join('').toUpperCase()
    : (Array.from((email || '').trim())[0] || '?').toUpperCase();
}
